import wretch from 'wretch';
import * as v from 'valibot';
import { TUser, UserSchema } from '../schemas/user';
import { localizedErrorHandlers } from '../localizedErrorHandlers';

export const getUser = async ({
  baseUrl,
}: {
  baseUrl: string;
}): Promise<TUser> => {
  const url = `${baseUrl}/user
`;
  const instance = wretch(url, {
    credentials: 'include',
  }).get();

  return localizedErrorHandlers(instance).json((response) => {
    const validatedResponse = v.safeParse(UserSchema, response);

    if (validatedResponse.success) {
      return validatedResponse.output;
    } else {
      console.error('fe-core | getUser | ', validatedResponse.issues);
      throw new Error('Invalid user response');
    }
  });
};
